<template>
    <div class="bg-color rounded-5 p-5">
        <div class="w-100 rounded-4">
            <div
                class="d-flex justify-content-between"
                style="background: rgb(241, 247, 255); border-radius: 27px 27px 0 0"
            >
                <div class="flex align-items-center list-page-header">
                    <h1 class="px-5 py-3 page-heading">Application Build History</h1>
                </div>
                <button class="text-button no-bg weight-600" style="margin-right: 10px; background: transparent">
                    <router-link class="text-link margin-0" :to="{ name: 'ApplicationBuilder' }">
                        <img src="@/assets/px/add.png" alt="" style="height: 20px" /> Create new Application
                    </router-link>
                </button>
            </div>
            <div class="w-100 bg-white" v-if="!application_list">
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>Fetching information...</h4>
                </div>
            </div>
            <div
                v-else-if="application_list.length > 0"
                class="dashboard-list-table profile-listing-body pb-2"
                style="width: 82vw"
            >
                <b-table
                    id="my-table"
                    :items="application_list.slice().reverse()"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    bordered
                    responsive
                >
                    <template #cell(s_no)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template #cell(application_name)="row">
                        <span :id="`applicationName-${row.index}`" class="column-ellipsis">
                            {{ row.item.application_name }}
                        </span>
                        <b-tooltip :target="`applicationName-${row.index}`" triggers="hover" placement="bottom">
                            {{ row.item.application_name }}
                        </b-tooltip>
                    </template>
                    <template #cell(created_at)="row">
                        {{ formattedDate(row.item.created_at) }}
                    </template>
                    <template #cell(modified_at)="row">
                        {{ formattedDate(row.item.updated_at) }}
                    </template>
                    <template #cell(action)="row">
                        <div class="d-flex justify-content-center align-items-center gap-2">
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Download"
                                target="#target"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/download.svg"
                                    alt=""
                                    style="height: 30px"
                                    id="target"
                                    @click="downloadDashboard(row.item)"
                                />
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Edit"
                                target="#target"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/edit-icon.png"
                                    alt=""
                                    style="height: 20px"
                                    id="target"
                                    @click="editDashboard(row.item)"
                                />
                            </ejs-tooltip>
                            <ejs-tooltip
                                class="tooltipcontainer"
                                content="Delete"
                                target="#target"
                                cssClass="customtooltip"
                            >
                                <img
                                    src="@/assets/px/delete-icon.png"
                                    alt=""
                                    style="height: 20px"
                                    id="target"
                                    @click="showDeleteAlertPopUp(row.item.id)"
                                />
                            </ejs-tooltip>
                        </div>
                    </template>
                </b-table>
                <div class="b-table-pagination">
                    <div class="pagination-count-per-page">
                        <div class="pagination-number-per-page">
                            <div>
                                <span>Per page:</span>
                            </div>
                            <div>
                                <select style="" @change="changeCountPerPage" :value="perPage">
                                    <option v-for="item in perPageOptions" :key="item" :value="item">
                                        {{ item }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <b-pagination
                        align="right"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                    ></b-pagination>
                </div>
            </div>
            <div class="w-100 bg-white" v-else>
                <div class="d-grid justify-content-center align-items-center py-5" style="min-height: 400px">
                    <h4>No Application found</h4>
                </div>
            </div>
            <div class="profile-delete-modal">
                <AlertDeleteApplicationTemplate
                    v-if="showDeleteAlert"
                    :open="showDeleteAlert"
                    @cancel="showDeleteAlert = false"
                    @handleDelete="handleDelete"
                />
            </div>
        </div>
        <Loading v-if="loading" />
    </div>
</template>

<script>
    import AlertDeleteApplicationTemplate from './delete_application_alert.vue';
    import Loading from '@/components/general/loading/loading.vue';
    import dayjs from '@/util/dayjs';
    import { applicationBuilder, upload } from '@/util/apiRequests';
    import { tryGetFilter } from '@/util/tryGetFilter';

    export default {
        name: 'ApplicationBuilderList',
        components: { AlertDeleteApplicationTemplate, Loading },
        data() {
            return {
                application_list: null,
                showDeleteAlert: false,
                indexTodelete: null,
                fields: [
                    { key: 's_no', label: 'S NO.', thStyle: { 'padding-left': '0 !important' }, class: 'table-col' },
                    { key: 'application_name', label: 'Application Name', class: 'table-col' },
                    { key: 'created_at', label: 'Created Date & Time', class: 'table-col' },
                    { key: 'created_by_name', label: 'Created By', class: 'table-col' },
                    { key: 'modified_at', label: 'Modified Date & Time', class: 'table-col' },
                    { key: 'updated_by_name', label: 'Modified By', class: 'table-col' },
                    { key: 'action', label: 'Action', class: 'action-sticky', stickyColumn: true, isRowHeader: true },
                ],
                totalRows: 0,
                // b-table properties
                storeKey: 'applications',
                perPageOptions: [5, 10, 20, 50, 100],
                currentPage: 1,
                perPage: 10,
                loading: true,
            };
        },
        methods: {
            async getApplicationList() {
                try {
                    let list = await this.$api.get(applicationBuilder.getAllApplications());
                    let data = list.data.data;
                    this.application_list = data;
                    this.totalRows = data.length;
                } catch (err) {
                    console.error(err);
                    this.$toasted.error('Failed to fetch applications');
                } finally {
                    this.loading = false;
                }
            },
            formattedDate(date) {
                return date ? dayjs(date).format('MM/DD/YYYY hh:mmA') : '';
            },
            showDeleteAlertPopUp(id) {
                this.showDeleteAlert = true;
                this.indexTodelete = id;
            },
            async handleDelete() {
                try {
                    let response = await this.$api.delete(applicationBuilder.deleteApplication(this.indexTodelete));
                    if (!response.data.success) {
                        throw response.data.error;
                    }
                    await this.getApplicationList();
                    this.$toasted.success('Dashboard is deleted successfully !');
                } catch (err) {
                    console.error('Failed to delete member profile', err);
                    this.$toasted.error('Failed to delete member profile');
                } finally {
                    this.showDeleteAlert = false;
                }
            },
            changeCountPerPage({ target: { value } }) {
                this.perPage = Number(value);
            },
            savedPagination() {
                const previousPagination = tryGetFilter(this.$store, this.storeKey);
                this.currentPage = previousPagination.currentPage ?? 1;
                this.perPage = previousPagination.perPage ?? 10;
            },
            async editDashboard(value) {
                const { id } = value;
                this.$router.push({ name: 'ApplicationBuilder', query: { id } });
            },
            async geturl(fileId) {
                const endpoint = upload.getUrl();
                const response = await this.$api.post(endpoint, { fileId });
                if (!response.data.success) {
                    throw response.data.error;
                }
                return response.data.url;
            },
            async downloadDashboard(value) {
                try {
                    let applogo = await this.geturl(value.app_logo);
                    let dashboarddata = {
                        id: value.id,
                        application_name: value.application_name,
                        android_ios_id: value.android_ios_id,
                        company_belongs: value.company_belongs,
                        dashboard_belongs: value.dashboard_belongs,
                        app_logo: applogo,
                    };
                    // Convert the value to a JSON string with indentation
                    const jsonString = JSON.stringify(dashboarddata, null, 2);
                    // Create a Blob from the JSON string
                    const blob = new Blob([jsonString], { type: 'application/json' });
                    // Create a temporary link element
                    const link = document.createElement('a');
                    // Set the download attribute with a filename
                    link.download = `application_${value.id || 'data'}.json`;
                    // Create a URL for the Blob and set it as href
                    link.href = URL.createObjectURL(blob);
                    // Append the link to the body (required for Firefox)
                    document.body.appendChild(link);
                    // Programmatically click the link to trigger download
                    link.click();
                    // Clean up
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                } catch (err) {
                    this.$toasted.error('Failed to download application data');
                    console.error(err);
                }
            },
        },
        async created() {
            this.savedPagination();
            await this.getApplicationList();
        },
        watch: {
            currentPage: function (val) {
                this.$store.commit('filters/updateFilter', {
                    stateKey: this.storeKey,
                    criteria: {
                        perPage: Number(this.perPage),
                        currentPage: Number(val),
                    },
                });
            },
            perPage: function (val) {
                this.$store.commit('filters/updateFilter', {
                    stateKey: this.storeKey,
                    criteria: {
                        currentPage: Number(this.currentPage),
                        perPage: Number(val),
                    },
                });
            },
        },
    };
</script>

<style scoped>
    .bg-color {
        background-color: rgba(255, 255, 255, 0.9);
    }

    .text-button a,
    .text-button a:hover,
    .text-button:hover {
        background-color: #5057c3;
        color: white;
        padding: 10px;
        border-radius: 10px;
    }

    .list-page-header {
        display: block;
        margin: 0;
        padding: 0;
        background: none;
    }
</style>

<style>
    .dashboard-list-table table tbody tr > td:first-child {
        padding-left: 2.5em !important;
    }

    .dashboard-list-table .b-table-sticky-column:last-child {
        right: 0;
        min-width: 100px;
    }

    .dashboard-list-table .action-sticky {
        min-width: 150px;
        box-shadow: -10px 0px 10px 1px #aaaaaa;
    }

    .dashboard-list-table .table-col {
        max-width: 150px;
        text-overflow: ellipsis;
        text-wrap: nowrap;
    }
</style>
